const APP_CONFIG = {
    REACT_APP_URL: "https://thesustain.net",
    REACT_APP_FRONTDASHBOARD_URL: "https://thesustain.net/dashboard",
    APP_DASBOARD_LOGIN_URL: "https://dashboard.thesustain.net/login",
    APP_DASBOARD_REG_URL: "https://dashboard.thesustain.net/register",
    APP_BACKEND_URL: "https://dashboard.thesustain.net",

    APPNAME: "The Sustain",

    REACT_APP_API_URL: "https://dashboard.thesustain.net/api",
    REACT_APP_API_CLIENT_ID: "4",
    REACT_APP_API_CLIENT_SECRET: "2EBKzeXGq6OpI3Qy9u3oEEZWxlgvOIAkUDnm5Kcb",
    REACT_APP_DASHBOARD_URL: "https://dashboard.thesustain.net",

    REACT_APP_STRIPE_PUBLIC_KEY: "pk_test_51SCa8REHViWHBosKuUOtqwfPEYEGPwSXAKQNaLGEDuUosjGkYoiwUH50ZeBZlgoihfhW4VPnE5CFvzSOy3qNTjGg00wPXT3knn",

    SITE_KEY : '6LdQ_DArAAAAAO3_Peb44aXpvySioIL1lXvuvlQr',
    REACT_APP_ENV: "production",
    HTTPS: true,
    RECAPTCHA_SITE_KEY: "6LdQ_DArAAAAAO3_Peb44aXpvySioIL1lXvuvlQr",
    RECAPTCHA_SECRET_KEY: "6LdQ_DArAAAAANeJ_YJCm8GDFdUgYa1KXMvv6yqu",

    REACT_APP_OAUTH_GOOGLE: "https://dashboard.thesustain.net/oauth/google",
    REACT_APP_OAUTH_FACEBOOK: "https://dashboard.thesustain.net/oauth/facebook",

    REACT_APP_URL_NO_COLLECTION: "https://thesustain.net",
    MY_SECRET_KEY:"pk_test_jGg00wPXT3knn",
    BACKEND_APP_URL_NO_COLLECTION: "https://dashboard.thesustain.net/",
    DONATION_APP_URL_NO_COLLECTION: "https://thesustain.assoconnect.com/collect/description/555345-u-adhesion-a-thesustain",
    ACESS_USERS: [
        {
            user_email: "admin@thesustain-soutien.com",
            acces_code: "tacces-2026",
        },
        {
            user_email: "yemmbackpierre@gmail.com",
            acces_code: "yacces-2026",
        },
    ]
};

export default APP_CONFIG;
